import { EtiquetasGenerales_EN } from './Genericos/EtiquetasGenerales_EN';

const EtiquetasModulo = {
    LoginScreen: {
        Et_BotonAccionAcceso: "SIGN IN",
        Et_BotonAccionAccesoAAD: "Continue with Office 365",
        Et_TituloPrincipal: "Hello,",
        Et_txtUsuario: "Email Address *",
        Et_txtPassword: "Password *",
        Et_txtRemenber: "Remember Me",
        Et_txtLoginExterno: "Sign in with ",
        Et_RecuperarCont: "Forgot your password?",
        Et_Copyright: "Copyright © 2025 CLASS Limitless, is a trademark",
    },
    PerfilUsuario: {
        Et_BotonAccion: "Save Data",
        Et_TituloPrincipal: "User Profile",
        Et_txtNombre: "First Name *",
        Et_txtApellidos: "Last Name *",
        Et_txtCorreo: "Email Address *",
        Et_txtNotificaciones: "I want to receive news and updates by email",
        Et_txtContrasena: "Password *",
        Et_txConfirmarContrasena: "Confirm Password *",
        Et_btnSelecionImagen: "Select an image"
    },
    RegistrarUsuario: {
        Et_BotonAccion: "REGISTER",
        Et_TituloPrincipal: "Registration",
        Et_txtNombre: "First Name *",
        Et_txtApellidos: "Last Name *",
        Et_txtCorreo: "Email Address *",
        Et_txtNotificaciones: "I want to receive news and updates by email",
        Et_txtContrasena: "Password *",
        Et_txConfirmarContrasena: "Confirm Password *"
    },
    RecuperarContrasena: {
        Et_BotonAccion: "CONTINUE",
        Et_BotonRegresar: "GO BACK",
        Et_TituloPrincipal: "Forgot Your Password?",
        Et_Cuerpo: "Enter an email address and we will gladly send you a link to add the new password.",
        Et_txtCorreo: "Email Address *"
    },
    CambiarContrasena: {
        Et_BotonAccion: "CHANGE",
        Et_BotonRegresar: "GO BACK",
        Et_TituloPrincipal: "Forgot Your Password?",
        Et_Cuerpo: "Password Policies",
        Et_txtContrasena: "New Password *",
        Et_txtConfirmar: "Confirm Password *"
    },
    PoliticasContrasena: {
        Et_PoliticasContrasena: "Password Policies",
        Et_Minimo: "Minimum Size: ",
        Et_Maximo: "Maximum Size: ",
        Et_Numeros: "Numeric characters",
        Et_Vocales: "Must enter at least one vowel",
        Et_Mayuscula: "Must enter at least one uppercase letter",
        Et_Minuscula: "Must enter at least one lowercase letter",
        Et_CEspecial: "Must enter at least one special character",
        Et_Confirmacion: "Matches the confirmation password",
        Et_Historico: "The password can't be repeated within the last ",
        Et_Caracteres: " characters"
    },
    RecuperarContrasenaSatisfactorio: {
        Et_TituloPrincipal: "Check your email!",
        Et_Cuerpo: "We have just sent you an email with instructions on how to change your password and log in again.",
        Et_TxtCorreo: "If you have any questions or issues, please contact us at this email address: ",
        Et_Correo: "class-u@gmail.com",
        Et_BotonRegresar: "SIGN IN",
    },
    PlantillaCorreo: {
        Et_Topic: "Password Recovery",
        Et_Header: "Dear: ",
        Et_Body: "This email was automatically sent to reset your password due to the recovery request made on ",
        Et_Body1: "Please follow the link below to update your password: ",
        Et_Body2: "The link is valid for ",
        Et_Body3: " hour(s).",
        Et_Footer: "Regards, "
    },
    Home: {
        Et_IrTienda: "Go to Store",
        Et_HomeTitulo: 'Constant Evolution!',
        Et_TituloFooter: '© Innovasoft 2025'
    }
};

const EtiquetasUnificadas = { ...EtiquetasGenerales_EN, ...EtiquetasModulo };

const Etiquetas_En = {
    Idioma: "EN",
    Etiquetas: EtiquetasUnificadas
};

export default Etiquetas_En;
